import AddPage from './AddPage';
import FilterConfig from './FilterConfig';
import { X } from 'lucide-react';
import { useTagActions } from '@/features/tags/hooks/useTagActions';
import { useTagStore } from '@/features/tags/store/useTagStore';

const SidebarHeader = () => {
  const activeFilters = useTagStore(state => state.activeFilters);
  const { clearFilters } = useTagActions();
  const [firstFilter, ...remainingFilters] = activeFilters;
  const hasFilters = activeFilters.length > 0;

  return (
    <div className="w-full flex items-center justify-between gap-2 mt-2 mb-1 px-1">
      <div className="flex min-w-0 items-center gap-2 pl-2">
        <h2 className="shrink-0 text-sm font-semibold">Notes</h2>
        {hasFilters && (
          <div className="flex min-w-0 items-center gap-1 rounded-sm bg-accent px-1.5 py-0.5 text-xs text-muted-foreground">
            <span className="max-w-24 truncate text-foreground">{firstFilter}</span>
            {remainingFilters.length > 0 && (
              <span className="shrink-0">+{remainingFilters.length}</span>
            )}
            <button
              type="button"
              title="Clear filters"
              onClick={clearFilters}
              className="ml-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm hover:text-foreground cursor-pointer"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        )}
      </div>
      <div className="flex shrink-0 gap-1">
        <FilterConfig showCount={!hasFilters} />
        <AddPage />
      </div>
    </div>
  );
};

export default SidebarHeader;
